import { render, staticRenderFns } from "./CollectionContentBlockForm.vue?vue&type=template&id=2b7830ce&"
import script from "./CollectionContentBlockForm.vue?vue&type=script&lang=ts&"
export * from "./CollectionContentBlockForm.vue?vue&type=script&lang=ts&"
import style0 from "./CollectionContentBlockForm.vue?vue&type=style&index=0&id=2b7830ce&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports